import { useShortIdContext } from '@air/provider-short-id';

import { usePublicPermissions } from '~/components/PublicPermissionsProvider';
import { canViewAllVersionsOnPublicShareLink } from '~/utils/canViewAllVersionsOnPublicShareLink';

/**
 * Whether the public share page may show the version browser / VERSIONS_BUTTON.
 * Clip-typed links are always false (FOUND-567); other object types use permissions.
 */
export const useCanViewAllVersionsOnPublicShareLink = () => {
  const { objectType } = useShortIdContext();
  const { permissions } = usePublicPermissions();

  return {
    canViewAllVersions: canViewAllVersionsOnPublicShareLink({ objectType, permissions }),
  };
};
